var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43035"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.667 8.49988L16.667 18.9999M16.667 18.9999L12.167 14.4999M16.667 18.9999L21.167 14.4999",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.6667 23.5L16.6667 23.5L22.6667 23.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M31.6667 16C31.6667 23.0711 31.6667 26.6066 29.47 28.8033C27.2734 31 23.7378 31 16.6667 31C9.59575 31 6.0601 31 3.8635 28.8033C1.66675 26.6066 1.66675 23.0711 1.66675 16C1.66675 8.929 1.66675 5.39335 3.8635 3.19675C6.0601 0.999998 9.59575 0.999998 16.6668 0.999999C23.7378 0.999999 27.2734 1 29.47 3.19675C31.6668 5.39335 31.6667 8.929 31.6667 16Z",
    stroke: "white",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadWhite);
export default __webpack_public_path__ + "static/media/download-white.2edbf19025a2973727ac64c115fca624.svg";
export { ForwardRef as ReactComponent };